// assets
import { IconEyeSearch, IconUserSearch } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconManualKycReview: IconEyeSearch,
  IconLoanApplicant: IconUserSearch
};

// ==============================|| MENU ITEMS - MANUAL REVIEW ||============================== //

const manualReview: NavItemType = {
  id: 'manual-review',
  title: 'Manual Review',
  type: 'group',
  icon: icons.IconManualKycReview,
  children: [
    {
      id: 'review-queue',
      title: 'Review Queue',
      type: 'item',
      url: '/manual-review/queue',
      icon: icons.IconLoanApplicant,
      breadcrumbs: false
    }
  ]
};

export default manualReview;